export default {
    id: "e1c8e430-a181-461b-a620-11abf1bfb1e0",
    name: "audio",
    icon: "mdi-cast-audio",
    title: "Audio",
    description: "An audio",
    category: "multimedia"
}